export const emptyField = 'N/a';